import $ from 'jquery';
import Placeholder from '../components/Placeholder';

export default class Connect {
  constructor(element) {
    this.element = element;
    this.$element = $(element);
    this.init();
    this.ready();
  }

  init() {
    this.element.querySelectorAll('.type-textfield').forEach((textfield) => {
      if (textfield && !textfield.placeholder) {
        textfield.placeholder = new Placeholder(textfield, { trim: true });
      }
    });
    this.$element.find('select option[value=""]').text('Select Option');
  }

  ready() {
    this.element.classList.add('ready');
  }
}
